import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import { useGetAvailablePackages, useGetPaymentLink } from "../../../../store/Apis/StripeApi";
import { useAppDispatch, useAppSelector } from "../../../../store/hooks";
import { freeFeatures, proFeatures } from "../../../../Helper";
import { StarsIcon } from "../../../../Custom-imeges/StarsIcon";
import ClearIcon from "@mui/icons-material/Clear";
import { IconButton } from "@mui/material";
import "../get-conversation/Popups.css";
import ThemeIcon from "../../../../Custom-imeges/ThemeIcon";
import { useEffect, useState } from "react";
import FormControlLabel from "@mui/material/FormControlLabel";
import Switch, { SwitchProps } from "@mui/material/Switch";
import { styled } from "@mui/material/styles";
import CornerBanner from "./CornerBanner";
import { setShowPlansModal } from "../../../../store/one-query/chatsSlice";
import { useNavigate } from "react-router-dom";

const IOSSwitch = styled((props: SwitchProps) => (
  <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
))(({ theme }) => ({
  width: 56,
  height: 32,
  padding: 0,
  display: "flex",
  alignItems: "start",
  "& .MuiSwitch-switchBase": {
    padding: 2,
    transform: "translateX(2px)",
    transitionDuration: "300ms",
    "&.Mui-checked": {
      transform: "translateX(23px)",
      color: "#fff",
      "& + .MuiSwitch-track": {
        background:
          "linear-gradient(90deg, #0568E0 0%, #12B6EA 51.5%, #65829C 100%)",
        opacity: 1,
        border: "1px solid #12B6EA",
        ...theme.applyStyles("dark", {
          backgroundColor: "#2ECA45",
        }),
      },
      "&.Mui-disabled + .MuiSwitch-track": {
        opacity: 0.5,
      },
    },
    "&.Mui-focusVisible .MuiSwitch-thumb": {
      color: "#FFFFFF",
      border: "6px solid #fff",
    },
    "&.Mui-disabled .MuiSwitch-thumb": {
      color: theme.palette.grey[100],
      ...theme.applyStyles("dark", {
        color: theme.palette.grey[600],
      }),
    },
    "&.Mui-disabled + .MuiSwitch-track": {
      opacity: 0.7,
      ...theme.applyStyles("dark", {
        opacity: 0.3,
      }),
    },
  },
  "& .MuiSwitch-thumb": {
    boxSizing: "border-box",
    width: 27,
    height: 27,
  },
  "& .MuiSwitch-track": {
    borderRadius: 50,
    background:
      "linear-gradient(270deg, #0C0F13 0%, #3A4B5A 51.5%, #65829C 100%)",
    border: "1px solid #65829C",
    opacity: 1,
    transition: theme.transitions.create(["background-color"], {
      duration: 500,
    }),
    ...theme.applyStyles("dark", {
      backgroundColor: "#39393D",
    }),
  },
}));
export const UpgradeSubscriptionPlanModal = () => {
  const { isPending:isAvailablePackagesPending } = useGetAvailablePackages();
  const [annualSub, setAnnualSub] = useState<boolean>(true);
  const showModal=useAppSelector((s)=>s.ChatsState.showPlansModal)
  const AvailablePackages=useAppSelector((s)=>s?.User?.availablePackages)
  const dispatch=useAppDispatch();
  const navigate=useNavigate();

  const goPayment = () => {
    window.open(annualSub?AvailablePackages?.annualSubscription.checkoutUrl:AvailablePackages?.monthlySubscription.checkoutUrl, "_self");
  };
  const toggleTheme = () => {
    setAnnualSub((prevState) => !prevState);
  };
   const handleCloseUpgradeToProModal = () => {
      dispatch(setShowPlansModal(false));
      navigate("/")
    };
  return (
    <div>
      <Modal
        sx={{ padding: "0", margin: "0"}}
        open={showModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box
          className="upgrade-plan-screen"
          sx={{
            width: "100%",
            height: "100%",
            position: "absolute",
            overflowY: "auto",
            scrollbarWidth: "none",
          }}
        >
          <Box className="upgrade-plan-plans">
            <IconButton
              aria-label="close"
              color="inherit"
              sx={{
                position: "absolute",
                top: "2%",
                right: { xs: "16px", md: "25px" },
              }}
              onClick={handleCloseUpgradeToProModal}
            >
              <ClearIcon />
            </IconButton>
            <p className="upgrade-screen-title">
              Your Ideas Deserve More Power
            </p>
            <p className="sub-header-upgrade mt-2 ">
              Access AI tools for writing, designing, editing, and creating all
              in one place.
            </p>
            <Box
              className="mt-2 mb-3"
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "baseline",
                }}
              >
                <p>Monthly</p>
                <Box className="ms-3 me-3">
                  <FormControlLabel
                    sx={{ marginLeft: "0px", marginRight: "0px" }}
                    control={
                      <IOSSwitch checked={annualSub} onChange={toggleTheme} />
                    }
                    label={undefined}
                  />
                </Box>
                <p>Yearly</p>
              </Box>
              <p
                className="saving-amount-annual"
                style={{
                  visibility: annualSub ? "hidden" : "visible",
                  height: "1em",
                }}
              >
                Save ${AvailablePackages?.yearlySavings} annually
              </p>
            </Box>
            <div className="plans">
              <div className="free_plan">
                <div className="title">
                  <h3 className="plan_title">Community (free)</h3>
                  <div className="plan-price">
                    <div className="price-coast">
                      <span className="price-currency">$</span>
                      <span className="price-mount">0</span>
                    </div>
                    <div className="price-duration">
                      USD / <br /> month
                    </div>
                  </div>
                </div>
                <button disabled className="upgrade_btn free border-0">
                  Your current plan
                </button>
                <p className="plan_description">
                  For people just getting started with Expertex
                </p>
                <div className="plan_features">
                  {freeFeatures.map((feature, i) => (
                    <div className="plan_feature" key={i}>
                      <div className="plan_arrow">
                        <img src="/images/GetConversations/icn-check-priceing-light.svg" />
                      </div>
                      <p>{feature}</p>
                    </div>
                  ))}
                </div>
              </div>
              <div style={{position:"relative"}}>
              <div className="pro_plan">
                <div className="title">
                  <div className="d-flex gap-2">
                    <StarsIcon className="pro-plan-icon" />
                    <h3 className="plan_title">Premium</h3>
                  </div>
                  <div className="plan-price new-plan-packages">
                    <div className="price-coast">
                      <span className="price-currency">$</span>
                      <span className="price-mount">{annualSub ? ((AvailablePackages?.annualSubscription.price ?? 0) / 12) : (AvailablePackages?.monthlySubscription.price ?? 0)}</span>
                    </div>
                    <div className="price-duration">
                      USD / <br /> month
                    </div>
                  </div>
                </div>
                <div
                  className="upgrade_btn pro border-0 c-pointer"
                  style={{
                    backgroundColor: isAvailablePackagesPending ? "#dce3e9" : "#12b6ea",
                    color: isAvailablePackagesPending ? "#8f9193" : "#fff",
                    cursor: isAvailablePackagesPending ? "wait" : "pointer",
                  }}
                  onClick={goPayment}
                >
                  Upgrade to premium
                </div>
                <p className="plan_description">You will enjoy :</p>
                <div className="plan_features">
                  {proFeatures.map((feature, i) => (
                    <div className="plan_feature" key={i}>
                      <div>
                        <img className="plan_arrow" />
                      </div>
                      <p>{feature}</p>
                    </div>
                  ))}
                </div>
              </div>
              {annualSub&&(<CornerBanner />)}
              </div>
            </div>
          </Box>
        </Box>
      </Modal>
    </div>
  );
};
